import { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

import { useStaff } from "../../api/staffApi";
import { MultiFileUpload } from "../../components/FileUpload";
import { useAddAnnouncement } from "../../api/noticeApi";

const AddAnnouncement = () => {
  const { data: staff } = useStaff();
  const { mutateAsync: addAnnouncement } = useAddAnnouncement();
  const [department, setDepartment] = useState<string>("");
  const navigate = useNavigate();
  const [files, setFiles] = useState<File[]>();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const departmentRadioGroup = useMemo(() => {
    if (!staff) return [];
    const { department } = staff.staff;
    const filters = [
      { value: "life", label: "생활스포츠" },
      { value: "pro", label: "전문스포츠" },
    ].filter((option) => department.includes(option.value));

    if (department.length === 2) {
      filters.splice(0, 0, { value: "all", label: "행정실" });
    }

    return filters;
  }, [staff]);

  const handleUpload = useCallback(async () => {
    try {
      await addAnnouncement({
        title,
        content,
        department: department === "all" ? ["life", "pro"] : [department],
        files,
      });
      alert("성공적으로 공지사항을 추가했습니다.");
      navigate("..");
    } catch (e) {
      console.error(e);
      alert(`공지 추가에 실패했습니다.`);
    }
  }, [title, content, department, files, addAnnouncement]);

  useEffect(() => {
    if (departmentRadioGroup.length === 1) {
      setDepartment(departmentRadioGroup[0].value);
    }
  }, [departmentRadioGroup]);

  return (
    <div className="narrowContent">
      <Link to=".." className="moveButton">
        뒤로가기
      </Link>
      <h1>공지 추가</h1>
      <div className="binary-grid">
        <>
          <p>제목</p>
          <input
            type="text"
            value={title}
            placeholder="제목을 입력하세요."
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />
        </>
        <>
          <p>담당부서</p>
          <RadioGroup
            row
            value={department}
            onChange={(e) => {
              setDepartment(e.target.value);
            }}
          >
            {departmentRadioGroup.map((department) => (
              <FormControlLabel
                key={department.label}
                value={department.value}
                control={<Radio />}
                label={department.label}
                onClick={() => setDepartment(department.value)}
              />
            ))}
          </RadioGroup>
        </>
        <>
          <p>내용</p>
          <textarea
            style={{ minHeight: "200px" }}
            value={content}
            placeholder="공지사항을 입력하세요."
            onChange={(e) => {
              setContent(e.target.value);
            }}
          />
        </>
        <>
          <p>첨부파일</p>
          <MultiFileUpload
            files={files}
            setFiles={setFiles}
            filename="announcementFile"
          />
        </>
      </div>
      <button onClick={handleUpload}>저장</button>
    </div>
  );
};

export default AddAnnouncement;
